import { create } from "zustand";

interface BoundingRectStore {
  boundingRects: { [key: string]: DOMRect };
  addBoundingRect: (id: string, rect: DOMRect) => void;
  removeBoundingRect: (id: string) => void;
}

export const useBoundingRectStore = create<BoundingRectStore>((set) => ({
  boundingRects: {},
  addBoundingRect: (id, rect) =>
    set((state) => ({ boundingRects: { ...state.boundingRects, [id]: rect } })),
  removeBoundingRect: (id) =>
    set((state) => {
      const newState = { ...state };
      delete newState.boundingRects[id];
      return newState;
    }),
}));
